import React, { Component } from 'react';
import { Router, Route, browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import store from './store'
import homePage from './js/views/homePage/homePage'
import categoryPage from './js/views/categoryPage/categoryPage'
import projectPage from './js/views/projectPage/projectPage'
import noMatch from './js/views/noMatch/noMatch'
import baseLayout from './js/layouts/baseLayout/baseLayout'
const history = syncHistoryWithStore(browserHistory, store)

export default (
  <Router history={history}>
    <Route component ={baseLayout}>
      <Route path="/" component={homePage} />
      <Route path="/:categorySlug" component={categoryPage} />
   		<Route path="/:categorySlug/:projectSlug" component={projectPage} />
    </Route>
		<Route path="*" component={noMatch}/> 
  </Router>
)      


/** WEBPACK FOOTER **
 ** ./src/App.js
 **/